import React, {Fragment, useContext, useEffect, useState} from "react";
import {useHistory} from 'react-router-dom'
import {Loader} from "../../components/Loader";
import {ServerContext} from "../../serverContext/ServerProvider";


export const Orders = () => {
    const history = useHistory()
    const {getAllOrders, orders} = useContext(ServerContext)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function wtf() {
            await getAllOrders(() => {
                setLoading(false)
            })
        }

        wtf()
    }, [])

    const getSummary = (goods) => {
        return goods.reduce((result, good) => result+good.amount, 0)
    }

    const getDate = (raw) => {
        const date = new Date(raw)
        return (date.getMonth()+1)+'.'+date.getDate()+'.'+date.getFullYear()+', '+date.getHours()+':'+date.getMinutes()
    }

    const orderClick = (id) => {
        history.push(`/admin/orders/${id}`)
    }

    return (
        <Fragment>
            {loading ? <Loader/> : (
                <div className='container-sm mt-5'>
                    <h2 style={{marginTop:'200px'}}>Orders:</h2>
                    {orders.map(order => (
                        <div
                            className="row mb-5 mt-5 p-4 order_item"
                            onClick={() => orderClick(order._id)}>
                            <div className="col-4 text-dark">
                                <h4>{getDate(order.date)}</h4>
                            </div>
                            <div className="col-4 text-dark">
                                <h4 className='text-muted'>From: {order.user.name}</h4>
                            </div>
                            <div className="col-4 text-dark text-center">
                                <h4 className>{getSummary(order.goods)}$</h4>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Fragment>
    )
}